module.exports = __webpack_public_path__ + "static/ab2-aacc2bcc8d0f822ded340dba09595dd5.jpg";